import DOMPurify from 'isomorphic-dompurify';
import React from 'react';

import { getCookie } from '@/lib/utils/cookie';
import { useLoginModal } from '@/store/login';

import * as S from './style';

export default function Floating({
  floatingText,
  buttonText,
  url,
  isNewTab,
  hasLoginOption,
}: {
  floatingText: string;
  buttonText: string;
  url: string;
  isNewTab: boolean;
  hasLoginOption: boolean;
}) {
  const { open: setLoginModal } = useLoginModal();
  const checkIsLogin = () => {
    const hasUserInfoCookie = getCookie('userinfo');
    const hasAccessTokenCookie = getCookie('token');

    return hasUserInfoCookie && hasAccessTokenCookie;
  };

  const mobileText = floatingText.split(/<br\s*\/?>/i).join('<br>');

  function handleClickFloatingButton() {
    if (!checkIsLogin() && hasLoginOption) {
      setLoginModal(url);
      return;
    }
    isNewTab ? window.open(url, '_blank') : (window.location.href = url);
  }

  return (
    <S.Background>
      <S.Wrapper>
        <S.MobileText
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mobileText) }}
        />
        <S.DesktopText
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(floatingText) }}
        />
        <S.Cta onClick={handleClickFloatingButton}>{buttonText}</S.Cta>
      </S.Wrapper>
    </S.Background>
  );
}
